export default __webpack_public_path__ + "static/media/Avatar-0.7da79d90.png";